<template>
  <div>
    <section class="container section page-header section is-main-section">
      <div class="modal" :class="{ 'is-active': toggleFilter }">
        <div class="modal-background"></div>
        <form class="modal-card is-small" style="width: 80rem">
          <header class="modal-card-head">
            <p class="modal-card-title">
              <strong>Add {{ kit.name }} Mapping</strong>
            </p>
            <button class="delete" type="button" @click="gotoList()"></button>
          </header>
          <section class="modal-card-body">
            <form
              @submit.prevent="onSubmit"
              enctype="multipart/form-data"
              name="SaveWowKitMapping"
            >
              <div>
                <card-component>
                  <div class="columns form-row">
                    <div class="column is-half">
                      <div class="field">
                        <label class="label">
                          {{
                            responseData[0]
                              ? responseData[0].franchiseeModel
                                ? responseData[0].studentClass
                                  ? 'Kits'
                                  : 'Center Type'
                                : 'Class Name'
                              : 'Kits'
                          }}
                          <span class="requir">*</span>
                        </label>
                        <div class="control select is-fullwidth">
                          <select
                            required
                            v-model.trim="selectedMappingObj.KitID"
                          >
                            <option value>---Select---</option>
                            <option
                              v-for="product in responseData"
                              v-bind:key="product.id"
                              v-bind:value="product.id"
                            >
                              {{
                                (product.franchiseeModel
                                  ? product.franchiseeModel.title
                                  : '') +
                                (product.studentClass
                                  ? product.studentClass.name
                                  : '') +
                                (product.subscriptionMonth > 0
                                  ? ` Subscribe ${product.subscriptionMonth} Month`
                                  : '')
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="columns form-row"></div>
                  <div class="columns form-row">
                    <div class="column is-6">
                      <div class="field">
                        <b-tooltip
                          label="ProductID, Qty E.g 10,5"
                          position="is-right"
                          multilined
                        >
                          <label class="label">
                            Product Id & QTY
                            <span class="requir">*</span>
                          </label>
                        </b-tooltip>
                        <div class="control">
                          <textarea
                            v-model="selectedMappingObj.pidqty"
                            type="text"
                            class="textarea is-medium"
                            maxlength="300"
                            pattern="[0-9]"
                            placeholder="Product-Id, Quantity   e.g{2,5}"
                            @input="makeAray"
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <footer class="column has-text-right">
                    <button class="button is-success" type="submit">
                      Save
                    </button>
                  </footer>
                </card-component>
              </div>
            </form>
          </section>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import _ from 'lodash'

export default {
  name: 'SaveKitMapping',
  props: ['kitType', 'kitID'],

  data () {
    return {
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      toggleFilter: true,
      kitData: [],
      kit: {},
      responseData: [],
      productIDListing: [],
      final: [],
      getTitle: 'Add Mapping',
      selectedMappingObj: {
        productID: '',
        KitID: '',
        productName: '',
        quantity: '',
        minQuantity: 1,
        maxQuantity: 100,
        margin: '',
        pidqty: ''
      },
      loadingComponent: null
    }
  },

  components: {
    CardComponent
  },

  created () {
    this.onStart()
  },
  watch: {
    kitType: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onStart()
      }
    }
  },
  methods: {
    makeAray: function () {
      let tempArray1 = this.selectedMappingObj.pidqty.trim().split('\n')
      this.final = tempArray1.map((a) => {
        let finalObj = a.split(',')
        return {
          productID: finalObj[0],
          quantity: finalObj[1],
          minQuantity: this.selectedMappingObj.minQuantity,
          maxQuantity: this.selectedMappingObj.maxQuantity
        }
      })
    },
    onStart: async function () {
      this.kit = _.find(this.constantKit, (item) =>
        _.isEqual(item.route, this.kitType)
      )
      if (_.isEmpty(this.kit)) {
        this.$router.push({
          name: 'listKitMapping',
          params: { kitType: this.constantKit[0].route }
        })
      }
      this.getTitle = 'Add' + this.kit.name + ' Mapping'
      this.selectedMappingObj.KitID = ''
      await this.getKitType()
      await this.getProductID()
    },
    getKitType: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/kits?kitType=${this.kit.id}`
        )
        this.responseData = response.data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getProductID: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(
          `${constants.API_URL}/api/products/details/filter`
        )
        this.productIDListing = JSON.parse(JSON.stringify(response.data.rows))
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    async onSubmit (event) {
      this.hasClicked = true
      this.loader = true
      /* Add Record */
      try {
        await http.post(
          `${constants.API_URL}/api/kits/product-map/${this.selectedMappingObj.KitID}`,
          { products: this.final }
        )

        this.loader = false
        this.$router.push({
          name: 'listKitMapping',
          params: {
            kitType: this.kitType,
            kitID: this.selectedMappingObj.KitID
          }
        })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'List Saved successfully!',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving  List', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    productList: function () {
      const ListingArray = _.filter(this.productIDListing, [
        'productID',
        Number(this.selectedMappingObj.productID)
      ])
      if (ListingArray.length > 0) {
        this.selectedMappingObj.productName = ListingArray[0].StickerName
      } else {
        this.selectedMappingObj.productName = ''
        this.$buefy.dialog.alert({
          message: 'Product Id Not found !',
          type: 'is-danger'
        })
      }
    },
    gotoList: function () {
      this.toggleFilter = false
      this.$router.push({
        name: 'listKitMapping',
        params: { kitType: this.kitType, kitID: this.selectedMappingObj.KitID }
      })
    }
  },
  computed: {
    productData: function () {
      return this.productIDListing.filter((option) => {
        return (
          option.productID
            .toString()
            .toLowerCase()
            .indexOf(this.selectedMappingObj.productID) >= 0
        )
      })
    }
  }
}
</script>
